import { DNABox, Icon } from '@alucio/lux-ui';
import Iffy from '@alucio/lux-ui/src/components/util/Iffy/Iffy';
import React, { useState, useRef, useEffect, useContext } from 'react';
import { Pressable, ScrollView, StyleSheet } from 'react-native';
import { ATTENDEE_GAP } from '../Attendee/Attendee';
import { ActionType, AttendeesOrderContext } from '../../AlucioVideoProvider/AttendeesOrderProvider/AttendeesOrder';
import { useMeetingControls } from '@alucio/video';
let max_participant_width = 216 + ATTENDEE_GAP; // video size + margin
const styles = StyleSheet.create({
    arrowIcon: {
        color: 'rgba(255, 255, 255, 0.8)',
        height: 20,
        width: 20,
    },
    disabledIcon: {
        color: 'rgba(255, 255, 255, 0.24)',
    },
    attendeesContainer: {
        flexDirection: 'row',
        marginRight: 8,
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
});
const NavigationArrow = (props) => {
    const { videoSize } = useMeetingControls();
    return (React.createElement(Pressable, { onPress: props.onPress, disabled: props.isDisabled },
        React.createElement(DNABox, { alignX: "center", alignY: "center", style: {
                width: 24,
                height: videoSize.container.height,
                backgroundColor: 'rgba(0, 0, 0, 0.64)',
            } },
            React.createElement(Icon, { name: props.icon, style: [
                    { width: 24, height: 24 },
                    props.isDisabled ? { color: 'rgba(255, 255, 255, 0.4)' } : { color: 'rgba(255, 255, 255, 0.8)' },
                ] }))));
};
export function ScrollViewContainer(props) {
    const { dispatch } = useContext(AttendeesOrderContext);
    const [visibleAttendeeCount, setVisibleAttendeeCount] = useState(-1);
    const attendeesContainer = useRef(null);
    const { participants, isHost } = props;
    const endReached = useRef();
    const [selectedPage, setSelectedPage] = useState(1);
    const [numberOfPages, setNumberOfPages] = useState(1);
    const [availableSpace, setAvailableSpace] = useState(0);
    const [scrollWidth, setScrollWidth] = useState(0);
    const { videoSize, isRightSideBarVisible } = useMeetingControls();
    const currentLayoutWidth = useRef(0);
    max_participant_width = videoSize.container.width + ATTENDEE_GAP;
    const moveLeft = () => goTo(selectedPage - 1);
    const moveRight = () => goTo(selectedPage + 1);
    const goTo = (page, attendeeCount = undefined) => {
        var _a;
        const selectedPage = page === 0 ? 1 : page;
        setSelectedPage(selectedPage);
        dispatch({ type: ActionType.SET_SELECTED_PAGE, value: selectedPage });
        (_a = attendeesContainer === null || attendeesContainer === void 0 ? void 0 : attendeesContainer.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
            y: 0,
            x: max_participant_width * ((attendeeCount || visibleAttendeeCount) * (page - 1)),
            animated: true,
        });
        props.selectedPage && props.selectedPage(visibleAttendeeCount, selectedPage);
    };
    useEffect(() => {
        currentLayoutWidth.current = isRightSideBarVisible
            ? currentLayoutWidth.current - 180
            : currentLayoutWidth.current + 180;
        calculateLayout();
    }, [isRightSideBarVisible]);
    const calculateLayout = () => {
        const attendeesThatCanFit = Math.floor(((currentLayoutWidth.current) / (max_participant_width - 1)));
        const availableSpace = (currentLayoutWidth.current - (isRightSideBarVisible ? 280 : 0));
        setAvailableSpace(availableSpace);
        if (attendeesThatCanFit !== visibleAttendeeCount) {
            dispatch({ type: ActionType.SET_VISIBLE_ATTENDEES_COUNT, value: attendeesThatCanFit });
            setVisibleAttendeeCount(attendeesThatCanFit);
        }
    };
    useEffect(() => {
        const buildNumberPages = () => {
            if (scrollWidth > 0) {
                const requiredSize = participants * max_participant_width;
                const newNumberOfPages = Math.ceil(requiredSize / scrollWidth);
                setNumberOfPages(newNumberOfPages);
                goTo(selectedPage > newNumberOfPages ? newNumberOfPages : selectedPage, visibleAttendeeCount);
            }
        };
        props.selectedPage && props.selectedPage(visibleAttendeeCount, selectedPage);
        buildNumberPages();
    }, [scrollWidth, availableSpace, visibleAttendeeCount, participants]);
    return (React.createElement(DNABox, { fill: true, style: {
            maxWidth: isHost ? max_participant_width * 5 : max_participant_width * 4,
        }, onLayout: e => {
            currentLayoutWidth.current = e.nativeEvent.layout.width;
            calculateLayout();
        } },
        React.createElement(DNABox, { appearance: "col" },
            React.createElement(DNABox, { appearance: "row" },
                React.createElement(Iffy, { is: participants > visibleAttendeeCount && availableSpace >= max_participant_width },
                    React.createElement(DNABox, { style: { marginLeft: 8 } },
                        React.createElement(NavigationArrow, { isDisabled: selectedPage === 1, icon: 'chevron-left', onPress: moveLeft }))),
                React.createElement(ScrollView, { onLayout: ({ nativeEvent }) => { setScrollWidth(nativeEvent.layout.width); }, horizontal: true, nativeID: 'participant-scroll-view', onScroll: ({ nativeEvent }) => {
                        const { layoutMeasurement, contentOffset, contentSize } = nativeEvent;
                        endReached.current = layoutMeasurement.width + Math.ceil(contentOffset.x) >= contentSize.width;
                    }, ref: attendeesContainer, style: [styles.attendeesContainer, {
                            maxWidth: max_participant_width * visibleAttendeeCount,
                            minWidth: max_participant_width * visibleAttendeeCount,
                        }] }, props.children),
                React.createElement(Iffy, { is: participants > visibleAttendeeCount && availableSpace >= max_participant_width },
                    React.createElement(NavigationArrow, { isDisabled: selectedPage === numberOfPages, icon: 'chevron-right', onPress: moveRight }))))));
}
//# sourceMappingURL=ScrollViewContainer.js.map